import { ReactNode, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import StaffInfoRequestGate from '../staff/StaffInfoRequestGate';

interface AppLayoutProps {
	children: ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => {
	const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

	const toggleMobileSidebar = () => {
		setIsMobileSidebarOpen(prev => !prev);
	};

	const closeMobileSidebar = () => {
		setIsMobileSidebarOpen(false);
	};

	return (
		<div className="flex flex-col h-screen overflow-hidden bg-[#f5f7fa] dark:bg-gray-900 transition-colors duration-300">
			{/* Header - Full width at top */}
			<Header onMenuToggle={toggleMobileSidebar} isMobileSidebarOpen={isMobileSidebarOpen} />

			{/* Main Layout - Sidebar + Content fill remaining height */}
			<div className="flex flex-1 overflow-hidden relative">
				{/* Sidebar - Fixed width, full height */}
				<Sidebar isOpen={isMobileSidebarOpen} onClose={closeMobileSidebar} />

				{/* Main content - Scrollable */}
				<main className="flex-1 overflow-y-auto p-5 md:p-[30px]">
					<div className="max-w-[1400px] mx-auto">{children}</div>
				</main>
			</div>

			{/* Staff-only; renders nothing for other roles. */}
			<StaffInfoRequestGate />
		</div>
	);
};

export default AppLayout;
